// extracted by mini-css-extract-plugin
export var button = "button_button__Wtw0h";
export var disabledSecondary = "button_disabledSecondary__et++z";
export var outline = "button_outline__bdL73";
export var primary = "button_primary__aDRo8";